/**
 * @generated SignedSource<<bc160f8e6bd74ea68616e7664236648d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type oneSectionTopWidgetQueue$data = ReadonlyArray<{
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"homeSecondaryContentItemContent" | "sectionTopLeadPrimaryContentItemContent">;
  };
  readonly " $fragmentType": "oneSectionTopWidgetQueue";
}>;
export type oneSectionTopWidgetQueue$key = ReadonlyArray<{
  readonly " $data"?: oneSectionTopWidgetQueue$data;
  readonly " $fragmentSpreads": FragmentRefs<"oneSectionTopWidgetQueue">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "withCarousel"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "oneSectionTopWidgetQueue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeSecondaryContentItemContent"
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "withCarousel",
                  "variableName": "withCarousel"
                }
              ],
              "kind": "FragmentSpread",
              "name": "sectionTopLeadPrimaryContentItemContent"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "ae63e93b6b63b9287820faa660c06931";

export default node;
